import styled from 'styled-components';

export const Plug = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Image = styled.div`
  width: 7.2rem;
  height: 7.2rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.darkBlue};
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Title = styled.span`

  ${(props) => props.theme.fonts.interSemibold24};
  color: ${(props) => props.theme.colors.white100};
  margin-top: 1.6rem;

`;
export const Description = styled.span`

  ${(props) => props.theme.fonts.interSemibold13Auto};
  color: ${(props) => props.theme.colors.secondary};
  margin-top: .8rem;

`;